import {defineMessages} from 'react-intl';

export default defineMessages({
	creditCard: {
		id: 'flyout.myAccount.paymentMethods.creditCard',
		defaultMessage: 'Credit Card',
	},
	expires: {
		id: 'flyout.myAccount.paymentMethods.expires',
		defaultMessage: 'Expires',
	},
});
